import { render, staticRenderFns } from "./CallFeeDetail.vue?vue&type=template&id=78a0735e"
import script from "./CallFeeDetail.vue?vue&type=script&lang=js"
export * from "./CallFeeDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports